import styled, { css } from 'styled-components'

import { Button as InterButton } from '@interco/inter-ui/components/Button'

const touchHoverResetPrimary = css`
  @media (hover: none), (pointer: coarse) {
    &:hover:enabled:not(:active) {
      background: var(--button-background-color);
    }
  }
`

const touchHoverResetSecondary = css`
  @media (hover: none), (pointer: coarse) {
    &:hover:enabled:not(:active) {
      background-color: transparent;
      border-color: var(--button-secondary-border-color);
    }
  }
`

export const Button = styled(InterButton).attrs({ variant: 'primary' })`
  align-self: end;
  margin: 24px 0 0;
  width: 100%;
  ${touchHoverResetPrimary};
`

export const ButtonSecondary = styled(InterButton).attrs({ variant: 'secondary' })`
  align-self: end;
  margin: 24px 0 0;
  width: 100%;
  ${touchHoverResetSecondary};
`
